/// <amd-module name="Test/TestPlansHubRefresh/Pivots/ExecutePivot/Redux/PointsFilterReducer" />
import { default as produce } from "immer";
import { PointsActions, PointsActionsTypes } from "Test/TestPlansHubRefresh/Pivots/ExecutePivot/Redux/PointsActions";
import { ITestHubExecuteFilterState } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshContracts";

export function PointsFilterReducer(state: ITestHubExecuteFilterState, action: PointsActions): ITestHubExecuteFilterState {
    state = state || ({} as ITestHubExecuteFilterState);

    return produce(state, (draftState: ITestHubExecuteFilterState) => {
        switch (action.type) {
            case PointsActionsTypes.updateFilteredTestPoints:
                draftState.filteredTestPointIds = action.payload.filteredTestPoints;
                break;

            default:
                break;
        }
    });
}
